export default __webpack_public_path__ + "static/media/boon.08bd9a12.png";